import { Flex } from 'components/primitives';
import queryString from 'query-string';

export function XYSWap() {
  const config = {
    fromTokenAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    sourceChainId: '1',
    toTokenAddress: '0x664E4b17EA045fE92868821F3eE0a76a5dB38166',
    targetChainId: '25',
    amount: 1,
    slippage: '1',
    orientation: 'portrait',
    theme: 'light',
    lockmode: 'none',
    referrer: '0xc850EB4eCa8B8B1464DA1C01e77aF9fd15211d24',
    commissionRate: 2000,
    pagecolor: '000000'
  };

  const url = queryString.stringify(config);
  const src = `https://widget.xy.finance/?${url}`;

  const width = 480;


  return (
    <Flex direction={'column'} css={{maxWidth:1200, margin:'auto', py:'$5', px:'$3'}}>
      <Flex css={{
            flexWrap: 'wrap',
            justifyContent: 'center', // Align items at the start
            gap: '$3',
            height: 732
      }}>
          <iframe 
            style={{
              borderRadius:18,
              minHeight: 556,
              height:'100%'
            }} 
            width={width} 
            src={src} 
          />
      </Flex>
    </Flex>
  );
}